import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BrowserComponent } from './browser.component';
import { HomeComponent } from './home.component';
import { FrontRootComponent } from './root.component';
import { ContentRecordsComponent, } from './content-records.component';
import { CartComponent } from './cart.component';

import { ContentPageComponent } from './content-page.component';
import { ContentRecordComponent } from './content-record.component';
import { ContentWritingComponent } from './content-writing.component';
import { ContentWritingsComponent } from './content-writings.component';
import { PageNotFoundComponent } from './page-not-found.component';
import { AuthGuard } from '../shared/auth-gard.service'; 

// Cannot be used in OAT mode (function call not allowed for some reason)
// var homeRoutes = () => {
//   let routes: any[] = [{ path: '',  component: HomeComponent }];
//   // Home routes
//   AppConfig.SUPPORTED_LANGUAGES.forEach(lg=>{
//     routes.push({ path: lg,  component: HomeComponent })
//   });
//   return routes;
// }

// Home routes hard-coded with languages for AOT mode
const contentRoutes: Routes = [
    { path: '',  component: HomeComponent },
    { path: 'fr',  component: HomeComponent },
    { path: 'en',  component: HomeComponent },
    // PAGE 
    { path: 'page/:url',  component: ContentPageComponent },
    // WRITINGS 
    { path: 'writings',  component: ContentWritingsComponent },
    { path: 'writing/:url',  component: ContentWritingComponent },
    // CATALOGUE 
    { path: 'catalogue', component: ContentRecordsComponent },
    { path: 'catalogue/:type', component: ContentRecordsComponent },
    { path: 'catalogue/:field/:value', component: ContentRecordsComponent },
    // CART
    { path: 'cart',  component: CartComponent },
    // PAGE NOT FOUND 
    { path: 'page-not-found', component: PageNotFoundComponent },
    // RECORD 
    { path: ':url', component: ContentRecordComponent },
];

// cannot be used in OAT: homeRoutes().concat(contentRoutes)
@NgModule({ 
  imports: [
    RouterModule.forChild([
      { path: '',  component: FrontRootComponent, children: contentRoutes },
      { path: ':lg',  component: FrontRootComponent, children: contentRoutes },
    ])
  ]
})
export class FrontRoutingModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/routing.module.ts